import React from 'react'
import { Button, TextSM } from '@reapit/elements'
import { Dropdown, DropdownContentItems } from '@reapitform/common-ui'
import { IDocuments } from '@reapitform/dashboard-ui'

export interface IDocumentActionButtonsProps {
  onSendForSigning?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onWithdraw?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onChangeExpiry?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onComplete?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onResendlink?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  isLoading?: boolean
  status?: IDocuments['status']
}

export const DocumentActionButtons: React.FC<IDocumentActionButtonsProps> = ({
  onChangeExpiry,
  onComplete,
  onSendForSigning,
  onWithdraw,
  onResendlink,
  isLoading,
  status,
}) => {
  switch (status) {
    case 'Draft':
      return (
        <Button key="btn-send" disabled={isLoading} intent="primary" onClick={onSendForSigning}>
          Send
        </Button>
      )
    case 'Blocked':
      return (
        <>
          <Button key="btn-withdraw" disabled={isLoading} intent="neutral" onClick={onWithdraw}>
            Withdraw
          </Button>
          <Button key="btn-send" disabled={isLoading} intent="primary" onClick={onSendForSigning}>
            Send
          </Button>
        </>
      )
    case 'Expired':
      return (
        <>
          <Button key="btn-withdraw" disabled={isLoading} intent="neutral" onClick={onWithdraw}>
            Withdraw
          </Button>
          <Button key="btn-change-expiry" disabled={isLoading} intent="primary" onClick={onChangeExpiry}>
            Change Expiry
          </Button>
        </>
      )
    case 'Signed':
      return (
        <>
          <Button key="btn-withdraw" disabled={isLoading} intent="neutral" onClick={onWithdraw}>
            Withdraw
          </Button>
          <Button key="btn-sign" disabled={isLoading} intent="primary" onClick={onComplete}>
            Sign
          </Button>
        </>
      )
    case 'Pending':
      return (
        <>
          <Button key="btn-resend" disabled={isLoading} intent="primary" onClick={onResendlink}>
            Resend
          </Button>
          <Dropdown
            alignment="right"
            trigger={<Button intent="neutral" buttonIcon={{ icon: 'more', position: 'only' }} />}
          >
            <DropdownContentItems key="btn-change-expiry" onClick={onChangeExpiry}>
              <TextSM>Change Expiry</TextSM>
            </DropdownContentItems>
            <DropdownContentItems key="btn-withdraw" onClick={onWithdraw}>
              <TextSM>Withdraw</TextSM>
            </DropdownContentItems>
          </Dropdown>
        </>
      )
    default:
      return null
  }
}
